<template>
  <div class="">
   
    <v-app>
      <v-flex hidden-md-and-down >
        <v-card flat>
          <v-toolbar app extended flat color="#fafafa">
            <v-toolbar-items>
              <router-link style="margin-left: 50%" :to="{name: 'Index'}">
                <img src="@/assets/Both/Logos/OlPejetaLogo.png" alt="" width="150%" style="margin-top: 10%" >
              </router-link>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-toolbar-items style="margin-top: 3%">
              <v-btn :depressed="true" flat color="primary" @click="navigate('Index')"><a class="knockout-color">Home</a></v-btn>
              <v-btn :depressed="true" flat color="primary" @click="navigate('SupportUs')"><a class="knockout-color">Support Us</a></v-btn>
             
              <v-btn :depressed="true" flat color="primary" @click="navigate('VolunteerProgram')"><a class="knockout-color">Immersive Conservation Experience</a></v-btn>
              <v-btn :depressed="true" flat color="primary" @click="navigate('RegisterMember')"><a class="knockout-color">Become a Member</a></v-btn>
              <v-menu offset-y absolute :full-width="true" v-if="local_route === true">
                <v-btn :depressed="true" slot="activator" flat color="grey">
                  <a class="earth"> Currency - {{currency}}</a>
                </v-btn>
                <v-list>
                  <v-list-tile v-for="(curency, key) in allCurrencies" @click="currencyChange(curency)" :key="key">
                    <v-list-tile-title>{{curency.currency_name}}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar-items>
          </v-toolbar>
        </v-card>
      </v-flex>
      <v-flex hidden-md-and-up>
        <v-toolbar app extended >
          <v-toolbar-items style="margin-top: 15%">
            <router-link :to="{name: 'Index'}">
              <img rel="preload" src="@/assets/Both/Logos/OlPejetaLogo.png" alt="" width="70%" >
            </router-link>
          </v-toolbar-items>
          <v-menu offset-y>
            <v-btn :depressed="true" color="primary" flat dark slot="activator"><v-icon>menu</v-icon></v-btn>
            <v-list>
              <v-list-tile flat color="primary" @click="navigate('Index')">Home</v-list-tile>
              <v-list-tile flat color="primary" @click="navigate('SupportUs')">Support Us</v-list-tile>
              <v-list-tile flat color="primary" @click="navigate('VolunteerProgram')">Volunteer Program</v-list-tile>
              <v-list-tile flat color="primary" @click="navigate('RegisterMember')">Become a Member</v-list-tile>
              <v-list-tile v-for="(curency, key) in allCurrencies" @click="currencyChange(curency)" :key="key">
                <v-list-tile-title>{{curency.currency_name}}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-flex>
      <v-content>
        <v-container fluid>
          <router-view></router-view>
        </v-container>
      </v-content>
    </v-app>
    <v-footer height="auto" color="white lighten-1">
      <v-layout justify-center row wrap>
        <v-btn class="v-btn v-btn--flat theme--light primary--text" v-for="(link, idx) in links" :key="idx">
          <strong><a :href="link.url" target="_blank" id="links">{{link.name}}</a></strong>
        </v-btn>
        <v-flex white lighten-2 py-3 text-xs-center primary--text xs12>
          &copy;2025 — <strong>Ol Pejeta Conservancy</strong>
        </v-flex>
      </v-layout>
    </v-footer>
  </div>
</template>

<script>
import MainNav from './Public/Basics/MainNav'
export default {
  components: { MainNav },
  name: 'HelloWorld',
  data () {
    return {
      msg: '',
      icons: [
        { 'url': '', 'icon_name': 'fa fa-facebook' },
        { 'url': '', 'icon_name': 'fa fa-twitter' },
        { 'url': '', 'icon_name': 'fa fa-google-plus' },
        { 'url': '', 'icon_name': 'fa fa-linkedin' },
        { 'url': '', 'icon_name': 'fa fa-instagram' }
      ],
      links: [
        { 'url': 'https://www.olpejetaconservancy.org/about-us/copyrights-and-credits/', 'name': 'Copyright and Credits' },
        { 'url': 'https://www.olpejetaconservancy.org/about-us/privacy-policy/', 'name': 'Privacy Policy' },
        { 'url': 'https://www.olpejetaconservancy.org/about-us/contact-us/', 'name': 'Contact Us' }
      ]
    }
  },
  computed: {
    currency: function () {
      return this.$store.state.CurrencyStore.browser_currency
    },
    local_route () {
      if (this.$route.meta.payment) {
        return false
      } else {
        return true
      }
    }
  },
  created () {
    this.$store.dispatch('get_all_currencies')
    localStorage.setItem('donation', JSON.stringify([]))
    // Live Chat Intergration
    window.__lc = window.__lc || {}
    window.__lc.license = 8631579
    var lc = document.createElement('script'); lc.type = 'text/javascript'; lc.async = true
    lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js'
    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(lc, s)
    // Google Analytics Intergration
    window.dataLayer = window.dataLayer || []
    lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://' + 'www.googletagmanager.com/gtag/js?id=AW-942857980')
    function gtag (){ dataLayer.push(arguments) }
    gtag('js', new Date())
    gtag('config', 'AW-942857980')
    // Facebook Pixel Integration
    !function(f,b,e,v,n,t,s) {
      if (f.fbq) return; n=f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) }
      if (!f._fbq)f._fbq = n; n.push = n; n.loaded =! 0; n.version = '2.0'
      n.queue = []; t = b.createElement(e); t.async =! 0
      t.src = v
      s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s) } (window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
      fbq('init', '429186911200180')
      fbq('track', 'PageView')
  },
  methods: {
    navigate: function (path) {
      this.$router.push({
        name: path
      })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @font-face { font-family: Earthwerk; font-weight: bold; src: url('./../assets/Both/Fonts/Earthwerk/PizzaDude.dk - Earthwerk.otf');}
  @font-face { font-family: Akzidenz; font-weight: bold; src: url('./../assets/Both/Fonts/Akzidenz Grotesk/akzidenz-grotesk-black.ttf');}
  @font-face { font-family: Knockout; font-weight: bold; src: url('./../assets/Both/Fonts/Knockout/knockout-htf-69-full-liteweight-1361516723.ttf');}
  .opc_green {
    color: #731533;
  }
  .opc_arial {
    font-family: Arial;
  }
  .green {
    background-color: #74a533;
    color: #ffffff;
  }
   .earth-color {
    font-family: Earthwerk;
    color: #74a533;
  } 
  .earth-color {
    font-family: 'Helvetica';
    color: #74a533;
  }
  .earth {
    font-family: Earthwerk;
  }
  .akzidenz-color {
    font-family: Akzidenz;
    color: #74a533;
  }
  .akzidenz {
    font-family: Akzidenz;
    font-size: 36px;
  }
  .knockout-color {
    font-family: Knockout;
    color: #74a533;
  }
  .knockout-color {
    font-family: Knockout;
    font-size: 22px;
  }
  a {
    text-decoration: none;
  }
  #links:hover {
    text-decoration: none;
    color: #74a533;
  }
</style>
